import { __extends } from "tslib";
import React from 'react';
import { Model } from "@singularsystems/neo-core";
import DropDown from '../DropDown/DropDown';
var PageSizeControl = /** @class */ (function (_super) {
    __extends(PageSizeControl, _super);
    function PageSizeControl() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pageSize = Model.PropertyAccessor.create(_this.props.pageManager, "pageSize");
        return _this;
    }
    PageSizeControl.prototype.render = function () {
        var _a;
        return (React.createElement("div", { className: "neo-pager-page-size" },
            React.createElement("span", null, (_a = this.props.label) !== null && _a !== void 0 ? _a : "Show: ",
                " "),
            React.createElement(DropDown, { select: { items: this.props.pageManager.pageSizeOptions.map(function (i) { return ({ id: i, name: i.toString() }); }) }, bind: this.pageSize })));
    };
    return PageSizeControl;
}(React.Component));
export default PageSizeControl;
